import React, { useEffect, useMemo, useState } from 'react'
import { cardiboxActions, cardiboxSelectors } from 'redux-cardibox'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import PageLayout from '../../../../components/PageLayout'
import { Box, Link, Stack, Typography, useTheme } from '@mui/material'
import { replaceEntityLinks } from '../../../../utils/FormatUtils'
import appConst from '../../../../constant/appConstants'
import LocalStorage from '../../../../business/storage/LocalStorage'
import { getMatrix } from '../../../../api/gerep/Simulateur'
import SimulationForm from '../components/SimulationForm'
import { simulatorGroupBy } from '../services/simulatorUtils'
import GuideGestionErrorPopin from '../components/GuideGestionErrorPopin'
import { getContratBaseSante } from '../../../webservices/contrats/contratsSelector'
import * as contratsActions from '../../../webservices/contrats/contratsActions'

const SimulationPage: React.FC = (
	{

	}) => {
	const intl = useIntl()
	const [matrix, setMatrix] = useState()

	useEffect(() => {
		getMatrix(LocalStorage.getToken())
			.then(matrix => setMatrix(matrix))
	}, [getMatrix])

	const groupedMatrix = useMemo(() => matrix && simulatorGroupBy(matrix), [matrix])

	return (
		<PageLayout title={intl.formatMessage({ id: 'simulation.title' })}>
			<SimulationForm matrix={groupedMatrix} />
		</PageLayout>
	)
}

export default SimulationPage
